import React from "react";
import {
  TableContainer,
  TableHeader,
  TableBody,
} from "../styled/userManagement/UserManageStyle";
import CompanyTBody from "./CompanyTBody";

export default function CompanyTable({ companyManagementData, onDataChange }) {
  return (
    <TableContainer>
      <TableHeader>
        <li>순번</li>
        <li>이름</li>
        <li>사업자 번호</li>
        <li>직종</li>
        <li>상태</li>
        <li>권한관리</li>
      </TableHeader>
      <TableBody>
        {companyManagementData.map((company, index) => (
          <CompanyTBody
            key={company.id || index}
            company={company}
            index={index}
            onDataChange={onDataChange}
          />
        ))}
      </TableBody>
    </TableContainer>
  );
}
